import { createGeoJsonLayer } from '../createGeoJsonLayer'
import { fromLonLat } from 'ol/proj'
import { boundingExtent } from 'ol/extent'

export async function generateAFACodeArea({ mapInstance }: { mapInstance: any }) {
  if (!mapInstance) return

  const map = mapInstance?.current
  if (!map) return

  try {
    const res = await fetch('https://api.cep.afa.codes/geo:iso_ext:BR')
    const data = await res.json()

    const geometry = data.geometry

    const layer = createGeoJsonLayer(geometry, 'afacodearea')
    layer.set('name', 'AFACODE_AREA')
    map.addLayer(layer)

    //IR ATÉ O LOCAL
    // Transforma as coordenadas do GeoJSON em extent (lembrando que estão em lon/lat)
    const polygonCoords = geometry.coordinates[0] as [number, number][]
    // Convertemos para o sistema de projeção do mapa
    const transformedCoords = polygonCoords.map((coord) => fromLonLat(coord))
    // Calcula o extent da área
    const extent = boundingExtent(transformedCoords)
    // Faz a câmera do mapa ir até o polígono
    mapInstance.current?.getView().fit(extent, {
      duration: 500, // animação opcional
      padding: [50, 50, 50, 50], // margem visual
      maxZoom: 18,
    })
  } catch (err) {
    console.error('Erro ao buscar polígono:', err)
  }
}
